module.exports = __webpack_public_path__ + "static/media/weather.adc03c0e.jpg";